import { render, staticRenderFns } from "./OtherOrderConfirmation.vue?vue&type=template&id=4fa84edc&"
import script from "./OtherOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OtherOrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OtherOrderConfirmation.vue?vue&type=style&index=0&id=4fa84edc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports